import { combineReducers } from 'redux'
import { projectDetailActions, projectDetailEpic, projectDetailReducer, ProjectDetailState } from './project-detail'
import { combineEpics } from 'redux-observable'
import { projectEditActions, projectEditReducer, ProjectEditState } from './project-edit'
import { projectListActions, projectListEpic, projectListReducer, ProjectListState } from './project-list'
import { settingsActions, settingsEpic, settingsReducer, SettingsState } from './settings'
import { TasksPageState, tasksReducer } from './task-list/task-list-reducer'
import { singleTaskReducer, SingleTaskState } from './task'
import { taskListActions } from './task-list/task-list-actions'
import { taskEpic } from './task-list/task-list-epic'
import { archiveActions, archiveEpic, archiveReducer, ArchiveState } from './archive'
import { searchActions, searchEpic, searchReducer, SearchState } from './search'
import { statisticsActions, statisticsEpic, statisticsReducer, StatisticsState } from './statistics'
import {taskFiltersActions, TaskFiltersState, taskFiltersReducer} from './task-list/TaskFilters'
import {contactsActions, contactsReducer, contactsEpic, ContactsState} from './contacts/users'

export const pagesActions = {
    projectDetailActions,
    projectEditActions,
    projectListActions,
    settingsActions,
    taskListActions,
    archiveActions,
    searchActions,
    statisticsActions,
    taskFiltersActions,
    contactsActions
}

export interface PagesState {
    projectDetail: ProjectDetailState,
    projectEdit: ProjectEditState,
    projectList: ProjectListState,
    settings: SettingsState,
    task: SingleTaskState,
    taskList: TasksPageState,
    archive: ArchiveState,
    search: SearchState,
    statistics: StatisticsState
    taskFilters: TaskFiltersState,
    contacts: ContactsState,
}

export const pagesReducer = combineReducers<PagesState>({
    projectDetail: projectDetailReducer,
    projectEdit: projectEditReducer,
    projectList: projectListReducer,
    settings: settingsReducer,
    task: singleTaskReducer,
    taskList: tasksReducer,
    archive: archiveReducer,
    search: searchReducer,
    statistics: statisticsReducer,
    taskFilters: taskFiltersReducer,
    contacts: contactsReducer,
})

export const pagesEpics = combineEpics(
    settingsEpic,
    projectDetailEpic,
    projectListEpic,
    taskEpic,
    archiveEpic,
    searchEpic,
    statisticsEpic,
    contactsEpic,
)
